import React from 'react'
import Header from '../Components/Header';
import Footer from '../Components/Footer';

function TheLerato() {

    return (
        <>
            <Header />
            <section id='the-lerato'>
                <div className='container'>
                    <div className='row my-5'>
                        <h4 className='text-primary text-start mb-0'>Japanese Syle Furnished Studio in Lerato, Makati</h4>
                        <p className='text-start'> <small><i class="bi bi-pin-map-fill"></i> Malugay cor Ayala Avenue, Makati</small></p>
                        <div className='row mb-3'>
                            <div className='col-lg-5'>
                                <div className='text-start'>
                                    <p className='mb-0'><b>About The Lerato by Alveo Land</b></p>
                                    <p>
                                        <small>
                                            A striking high-rise residential development in the richest city in the country, The Lerato by Alveo
                                            Land always attracts upward gazes along Malugay Street in Makati. The condo village boasts of more
                                            luxurious features, from relaxing greenery to enticing outdoor amenities.
                                            <br />
                                            <br />
                                            Built by a reputable developer Alveo Land, the residential enclave offers an ambiance of peace and quiet
                                            for urban dwellers. Those who prefer sophistication and tranquility can find a real home in Lerato in Bel-Air,
                                            Makati City..
                                        </small>
                                    </p>

                                    <p className='mb-0'><b>Why The Lerato Is a Perfect Condo Option in Makat?</b></p>
                                    <p>
                                        <small>
                                            Located in the posh neighborhood of Bel-Air, The Lerato by Alveo Land enables residents to embrace the peak experience
                                            of comfort and convenience. Imagine having the biggest shopping centers in the country a stone's throw away from your
                                            residence. Greenbelt and Glorietta can be reachable within five to 10 minutes.
                                            <br />
                                            <br />
                                            Other entertainment hubs, such as RCBC Theater, Ayala Triangle, and Makati Sports Club, are nearby. If you're keen on
                                            maintaining a lifestyle of convenience for your family, a unit for sale or rent is for you.
                                        </small>
                                    </p>
                                </div>
                            </div>
                            <div className='col-lg-7'>
                                <div id="TheLeratoProject" className="carousel slide" data-bs-ride="carousel">
                                    <div className="carousel-indicators">
                                        <button type="button" data-bs-target="#TheLeratoProject" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#TheLeratoProject" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                        <button type="button" data-bs-target="#TheLeratoProject" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                        <button type="button" data-bs-target="#TheLeratoProject" data-bs-slide-to="3" aria-label="Slide 4"></button>
                                        <button type="button" data-bs-target="#TheLeratoProject" data-bs-slide-to="4" aria-label="Slide 5"></button>
                                    </div>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato8.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato8.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato7.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato7.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato6.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato6.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato5.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato5.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato4.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato4.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="carousel-control-prev" type="button" data-bs-target="#TheLeratoProject" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target="#TheLeratoProject" data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </div>
                                <p className='d-xxl-none d-xl-none d-xxl-block d-lg-none d-xl-block'> <small><i>Tap to Enlarge</i></small></p>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <div className='col-lg-8'>
                                <div id="TheLeratoUnit" className="carousel slide" data-bs-ride="carousel">
                                    <div className="carousel-indicators">
                                        <button type="button" data-bs-target="#TheLeratoUnit" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                        <button type="button" data-bs-target="#TheLeratoUnit" data-bs-slide-to="1" aria-label="Slide 2"></button>
                                        <button type="button" data-bs-target="#TheLeratoUnit" data-bs-slide-to="2" aria-label="Slide 3"></button>
                                    </div>
                                    <div className="carousel-inner">
                                        <div className="carousel-item active">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato1.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato1.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Bed Room</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato2.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato2.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Dining and Kitchen</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                        <div className="carousel-item">
                                            <a href='https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato3.jpeg'>
                                                <img src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato3.jpeg"
                                                    className="img-fluid" alt="...">
                                                </img>
                                            </a>
                                            <div className="carousel-caption d-none d-md-block">
                                                <h4 className='mb-0'>Toilet and Bath</h4>
                                                <p className='mb-0'> <small><i>Click to Enlarge</i></small></p>
                                            </div>
                                        </div>
                                    </div>
                                    <button className="carousel-control-prev" type="button" data-bs-target="#TheLeratoUnit" data-bs-slide="prev">
                                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Previous</span>
                                    </button>
                                    <button className="carousel-control-next" type="button" data-bs-target="#TheLeratoUnit" data-bs-slide="next">
                                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                        <span className="visually-hidden">Next</span>
                                    </button>
                                </div>
                                <p className='d-xxl-none d-xl-none d-xxl-block d-lg-none d-xl-block'> <small><i>Tap to Enlarge</i></small></p>
                            </div>
                            <div className='col-lg-4'>
                                <div className='text-start text-small'>
                                    <p className=''>
                                        <b>The Lerato</b>
                                        <br />
                                        <small>Unit: TBP</small>
                                    </p>

                                    <b>Description:</b>
                                    <ul>
                                        <li><small>1 Studio Unit</small></li>
                                        <li><small>Japanese Style furnished</small></li>
                                        <li><small>32 sq.m. (344 sq.ft)</small></li>
                                        <li><small>1 Toilet and Bath</small></li>
                                        <li><small>Big amenities</small></li>
                                    </ul>
                                    <b>Unit Features:</b>
                                    <ul>
                                        <li><small>has Shower Heater</small></li>
                                        <li><small>has a Refrigerator</small></li>
                                        <li><small>has Electric Range</small></li>
                                        <li><small>has Microwave</small></li>
                                        <li><small>has Washing Machine and Dryer</small></li>
                                    </ul>
                                    <p>
                                        <small>
                                            Available for viewing
                                            <br />
                                            <b>PhP35,000 per month</b>
                                            <br />
                                            Minimum 12 months lease
                                        </small>
                                    </p>
                                    <div className='d-flex flex-row'>
                                        <a className='btn btn-success' href='/contact-us'>Contact us for Viewing</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row mb-3'>
                            <h4 className='text-start text-primary'>Amenities and Location</h4>
                            <div className='row mb-3'>
                                <div className='col-lg-6'>
                                    <a href="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato9.jpg">
                                        <img className="img-fluid pt-4"
                                            src="https://everra.s3.ap-southeast-1.amazonaws.com/ListingRent/Lerato/Lerato9.jpg"
                                            alt="...">
                                        </img>
                                    </a>
                                    <p className='d-xxl-none d-xl-none d-xxl-block d-lg-none d-xl-block'> <small><i>Tap to Enlarge</i></small></p>
                                </div>
                                <div className='col-lg-6'>
                                    <iframe width="100%" height="400rem"
                                        title="XQVNmgdYRUQ"
                                        src="https://www.youtube.com/embed/3Xq0CU_BmqY?autoplay=1&controls=1&loop=0&mute=0&rel=0&start=0">
                                    </iframe>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-5 text-start'>
                                    <p className='mb-0'><b>About Alveo Land</b></p>
                                    <p>
                                        <small>
                                            A household name in the real estate development industry, Alveo Land has been serving the upscale
                                            Filipino market for years. It boasts of excellence in every project, as it proudly carries the legacy
                                            of its parent company, Ayala Land. Aside from The Lerato in Makati, its notable projects include
                                            Portico in Pasig, Orean Place in Quezon City, and Park Cascades in Taguig. Because of the company's
                                            dedication to quality work, Alveo Land has won several awards over the years. In 2018, one of its projects,
                                            Solinea, bagged the title Best Premium Condo of the Year at the Lamudi Outlook Awards.
                                        </small>
                                    </p>
                                    <p className='mb-0'><b>About Makati City</b></p>
                                    <p>
                                        <small>
                                            The wealthiest city in the capital region, Makati accommodates various thriving industries,
                                            including financial services, real estate, manufacturing, and business process outsourcing.
                                            Its busiest zone is the Makati Central Business District (CBD), where multinational companies
                                            are headquartered. It accommodates sprawling retail amenities and affluent villages, too. Some
                                            of the most notable, towering skyscrapers in the country are in Makati, PBCom Tower, Petron Megaplaza,
                                            and G.T. International Tower, to name a few.
                                        </small>
                                    </p>
                                </div>
                                <div className='col-lg-7'>
                                    <iframe className="embed-responsive-item"
                                        width="100%" height="400rem"
                                        src="https://maps.google.com/maps?q=The%20lerato&t=&z=17&ie=UTF8&iwloc=&output=embed"
                                        frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default TheLerato